import React from "react";
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    Container,
    Grid,
    Stack,
    Typography,
} from "@mui/material";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import TableChartIcon from "@mui/icons-material/TableChart";

import { cardSx, sectionSubtitleSx, sectionTitleSx } from "./homeStyles";

function HomeHowItWorks() {
    const steps = [
        {
            icon: UploadFileIcon,
            step: "Шаг 1",
            title: "Загрузите документы",
            text: "Загрузите PDF-платежи и Excel из бухгалтерской или кадровой системы через удобный веб-интерфейс.",
        },
        {
            icon: DomainVerificationIcon,
            step: "Шаг 2",
            title: "Система проверит и подготовит файлы",
            text: "Qarzhy определит банк, проверит структуру документов, отсеет неподходящие файлы и подготовит корректные данные к обработке.",
        },
        {
            icon: AssignmentTurnedInIcon,
            step: "Шаг 3",
            title: "Автоматически выполнит сверку",
            text: "Система сопоставит ИИН, ФИО, счета, суммы и структуру выплат, чтобы быстро выявить расхождения и подозрительные случаи.",
        },
        {
            icon: TableChartIcon,
            step: "Шаг 4",
            title: "Получите готовый результат",
            text: "Вы получите понятную таблицу со статусами, приоритетом ошибок, итоговыми показателями и возможностью выгрузки в Excel.",
        },
    ];

    return (
        <Box id="how-it-works" sx={{ py: { xs: 6, md: 8 }, bgcolor: "white" }}>
            <Container maxWidth="xl">
                <Box textAlign="center" sx={{ mb: { xs: 4, md: 5 } }}>
                    <Typography variant="h3" sx={sectionTitleSx}>
                        Как это работает
                    </Typography>

                    <Typography sx={{ ...sectionSubtitleSx, maxWidth: 860, mx: "auto" }}>
                        Qarzhy использует двухэтапную обработку: сначала проверяет и
                        подготавливает документы, затем выполняет основную сверку. Это
                        помогает повысить точность результата и снизить риск ошибок.
                    </Typography>
                </Box>

                <Grid container spacing={{ xs: 2, md: 2.5 }}>
                    {steps.map((item) => {
                        const Icon = item.icon;

                        return (
                            <Grid size={{ xs: 12, md: 6, lg: 3 }} key={item.title}>
                                <Card
                                    sx={{
                                        ...cardSx,
                                        height: "100%",
                                        borderRadius: 4,
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            p: { xs: 2.2, md: 2.5 },
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <Chip
                                            label={item.step}
                                            color="primary"
                                            size="small"
                                            sx={{
                                                alignSelf: "flex-start",
                                                mb: 1.4,
                                                fontWeight: 700,
                                                borderRadius: 999,
                                                height: 28,
                                            }}
                                        />

                                        <Stack
                                            direction="row"
                                            spacing={1.2}
                                            alignItems="center"
                                            sx={{ mb: 1.3 }}
                                        >
                                            <Avatar
                                                sx={{
                                                    bgcolor: "rgba(37,99,235,0.10)",
                                                    color: "#2563eb",
                                                    width: 40,
                                                    height: 40,
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <Icon sx={{ fontSize: 20 }} />
                                            </Avatar>

                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    color: "#0f172a",
                                                    fontSize: { xs: "1rem", md: "1.04rem" },
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                        </Stack>

                                        <Typography
                                            sx={{
                                                color: "#475569",
                                                lineHeight: 1.68,
                                                fontSize: { xs: "0.95rem", md: "0.97rem" },
                                            }}
                                        >
                                            {item.text}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
}

export default HomeHowItWorks;